module.exports = __webpack_public_path__ + "static/media/Stores_Orange.19bc977c.svg";